/**
 * Focus style utilities for consistent focus states across the UI kit
 */
export type Variant = 'primary' | 'destructive';

export interface FocusStyleOptions {
  variant?: Variant;
  includeBorder?: boolean;
  includeRing?: boolean;
  customColor?: string;
}

/**
 * Get focus classes with customizable color and options
 */
export const getFocusClasses = (options: FocusStyleOptions = {}) => {
  const {
    variant = 'primary',
    includeBorder = true,
    includeRing = true,
  } = options;

  const classes: string[] = ['focus-visible:outline-none'];

  // Add ring if requested
  if (includeRing) {
    classes.push('focus-visible:ring-ring focus-visible:ring-4');
  }

  // Add border if requested
  if (includeBorder) {
    classes.push('focus-visible:border-1');
  }

  // Add shadow based on color
  switch (variant) {
    case 'primary':
      classes.push(`focus-visible:ring-blue-200`);
      break;
    case 'destructive':
      classes.push(`focus-visible:ring-red-200`);
      break;
  }

  return classes.join(' ');
};

const primaryFocusClasses = getFocusClasses({
  variant: 'primary',
  // includeBorder: false,
  // includeRing: false,
});
const destructiveFocusClasses = getFocusClasses({
  variant: 'destructive',
  // includeBorder: false,
  // includeRing: false,
});

export const focusVisibleClasses = {
  primary: primaryFocusClasses,
  destructive: destructiveFocusClasses,
};
